import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { LaserEyesProvider } from '@omnisat/lasereyes-react'
import { MAINNET, OKX, OYL, UNISAT, XVERSE } from '@omnisat/lasereyes-core'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

// Simple provider with MAINNET only
function DynamicLaserEyesProvider({ children }) {
  return (
    <LaserEyesProvider config={{ 
      networks: [MAINNET],
      defaultNetwork: MAINNET,
      walletProviders: [OKX, OYL, UNISAT, XVERSE],
      autoConnect: false
    }}>
      {children}
    </LaserEyesProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <DynamicLaserEyesProvider>
      <BrowserRouter useTransitions={false}>
        <App />
      </BrowserRouter>
    </DynamicLaserEyesProvider>
  </QueryClientProvider>
);


